import { Reducer } from 'redux';
import { createReducer } from 'redux-act';

import { PagesActions } from './pages.actions';
import { PagesState } from './pages.types';

const initialState: PagesState = {
  selected: 0,
};

export const pages = createReducer(
  (on) => {
    on(PagesActions.selectPage, (state, payload) => ({ ...state, selected: payload }));
  },
  initialState,
) as Reducer<PagesState>;
